import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import MuiBox from '@material-ui/core/Box';
import { useThemeProps } from '../../foundation';
var RcBox = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcBox' });
    // TODO: that ref don't include in mui props, use this way to apply ref to MuiBox, that will be fix in v5
    var addProps = { ref: ref };
    return React.createElement(MuiBox, __assign({}, addProps, props));
});
export { RcBox };
